package com.alpha.showcase.common.ui.play

import coil3.request.ImageRequest

internal actual fun ImageRequest.Builder.prepareBlurSource() = Unit
